import { Box, MenuItem, Button } from "@mui/material"
import { StyledTextField } from "components/inputs/StyledTextField"
import { SubmitHandler, useForm, Controller } from "react-hook-form"
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined"
import {
    defaultFilterValuesRfids,
    RfidStatus,
} from "layouts/rfid/utils/const.ts"

export interface IFormRfidFilter {
    cardHolder: string
    rfidNumber: string
    status: string
    type: "ALL" | "VEHICLE" | "DRIVER"
}

interface FilterProps {
    onSubmit: SubmitHandler<IFormRfidFilter>
}

export const RfidFilter = ({ onSubmit }: FilterProps) => {
    const { control, handleSubmit } = useForm({
        defaultValues: defaultFilterValuesRfids,
    })

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    width: "100%",
                    height: "56px",
                }}
            >
                <Controller
                    name="rfidNumber"
                    control={control}
                    render={({ field }) => (
                        <StyledTextField
                            id="drivers-page-rfidNumber"
                            data-cy="header-nav__cards--rfid-number"
                            label="Numéro de carte"
                            {...field}
                        />
                    )}
                />
                <Controller
                    name="cardHolder"
                    control={control}
                    render={({ field }) => (
                        <StyledTextField
                            id="drivers-page-lastName"
                            data-cy="header-nav__cards--card-holder"
                            label="Conducteur/Véhicule"
                            {...field}
                        />
                    )}
                />
                <Controller
                    name="status"
                    control={control}
                    render={({ field }) => (
                        <StyledTextField
                            id="drivers-page-status"
                            data-cy="header-nav__cards--status"
                            select
                            label="Statut"
                            defaultValue="all"
                            {...field}
                        >
                            <MenuItem
                                value="all"
                                data-cy="cards__status--all"
                            >Tous</MenuItem>
                            <MenuItem
                                value={RfidStatus.Active}
                                data-cy="cards__status--active"
                            >Active
                            </MenuItem>
                            <MenuItem
                                value={RfidStatus.Deactivate}
                                data-cy="cards__status--unactive"
                            >Desactivée
                            </MenuItem>
                        </StyledTextField>
                    )}
                />
                <Button
                    data-testid="FilterSubmit"
                    data-cy="header-nav__cards--submit"
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                        minWidth: "56px",
                        height: "56px",
                        aspectRatio: "1/1",
                        borderRadius: "10px",
                        "&:hover, &:focus": {
                            backgroundColor: "primary.hover",
                        },
                    }}
                >
                    <SearchOutlinedIcon
                        sx={{
                            color: "white",
                            fontSize: "2rem",
                        }}
                    />
                </Button>
            </Box>
        </form>
    )
}
